import React from "react";
import { externalLinkHandler, externalTarget } from "@/utils/openExternal";

const WHATSAPP_URL =
  "https://wa.me/34669024616?text=" +
  encodeURIComponent("Hola, escribo desde la web de Homeatope.");

export default function WhatsAppFab() {
  return (
    <a
      href={WHATSAPP_URL}
      target={externalTarget()}
      rel="noopener noreferrer"
      onClick={externalLinkHandler(WHATSAPP_URL)}
      data-testid="whatsapp-fab"
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full shadow-lg transition-transform hover:scale-105"
      style={{ backgroundColor: "#25D366", color: "white" }}
    >
      {/* Inline WhatsApp glyph SVG to avoid extra deps */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width="28"
        height="28"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M19.11 17.27c-.27-.14-1.6-.79-1.85-.88-.25-.09-.43-.14-.62.14-.18.27-.71.88-.87 1.06-.16.18-.32.2-.59.07-.27-.14-1.13-.42-2.16-1.34-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.41.12-.55.12-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.62-1.5-.85-2.05-.22-.54-.45-.46-.62-.47-.16-.01-.34-.01-.52-.01-.18 0-.48.07-.74.34-.25.27-.97.95-.97 2.32 0 1.37 1 2.7 1.14 2.88.14.18 1.97 3.02 4.78 4.23.67.29 1.19.46 1.59.59.67.21 1.28.18 1.76.11.54-.08 1.6-.65 1.82-1.28.23-.63.23-1.16.16-1.28-.07-.12-.25-.18-.52-.32zM16.02 4C9.39 4 4 9.36 4 15.96c0 2.11.56 4.17 1.62 5.99L4 28l6.27-1.63a12 12 0 0 0 5.75 1.47h.01c6.63 0 12.02-5.36 12.02-11.96 0-3.2-1.25-6.21-3.52-8.47A12.02 12.02 0 0 0 16.02 4zm0 21.81h-.01a10 10 0 0 1-5.08-1.39l-.36-.22-3.72.97.99-3.62-.24-.37a9.94 9.94 0 0 1-1.54-5.32c0-5.49 4.5-9.96 10.03-9.96 2.68 0 5.2 1.04 7.09 2.92a9.9 9.9 0 0 1 2.94 7.04c0 5.49-4.49 9.95-10.1 9.95z" />
      </svg>
    </a>
  );
}
